import AccessDenied from "../../components/AccessDenied";
import Form from "../../components/portal/Form";
import { useAuthStore } from "../../stores/store";
import { AuthenStoreType } from "../../types/authen";

export default function Portal() {
  const { user: auth } = useAuthStore((state) => state as AuthenStoreType);

  return (
    <div className="w-full h-screen bg-white">
      <div className="w-full h-full hidden md:grid md:grid-cols-2">
        <div className="col-span-1 bg-primary flex items-center justify-center bg-[url(/images/bg-login.webp)] bg-cover bg-center">
          <img src="/images/logo-essilor-luxottica.svg" alt="essilor-logo" />
        </div>
        <div className="col-span-1 flex items-center justify-center">
          {auth?.role !== "member" ? <AccessDenied /> : <Form />}
        </div>
      </div>
      <div className="flex items-center justify-center md:hidden h-full">
        {auth?.role !== "member" ? <AccessDenied /> : <Form />}
      </div>
    </div>
  );
}
